// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1FC6_","load7":"Spinner_load7__3g_H8"};